import { render, staticRenderFns } from "./ManageLawyerReminders.vue?vue&type=template&id=27521d23&scoped=true"
import script from "./ManageLawyerReminders.vue?vue&type=script&lang=js"
export * from "./ManageLawyerReminders.vue?vue&type=script&lang=js"
import style0 from "./ManageLawyerReminders.vue?vue&type=style&index=0&id=27521d23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27521d23",
  null
  
)

export default component.exports